import { IBannerProps } from 'mod/featureV2/Banner/interface';
import { IBanner, IBannerImage, IBannerVideo } from 'mod/featureV2/interface/banner';
import { BannerVideo } from 'mod/featureV2/Banner/BannerVideo';
import { BannerLargeImage } from 'mod/featureV2/Banner/BannerLargeImage';
import { BannerImage } from 'mod/featureV2/Banner/BannerImage';
import { isVideoUrl } from 'base/utils/file';
import { isPhone } from 'base/utils/client';

export function Banner(props: IBannerProps<IBanner & Record<string, any>>) {
    const { banner, largeScreenHeightFixed = false, heightFixed = false } = props;
    if (!banner.src) {
        return null;
    }

    if (isVideoUrl(banner.src)) {
        return <BannerVideo {...(props as IBannerProps<IBannerVideo>)}/>;
    }

    if ((!isPhone && largeScreenHeightFixed) || heightFixed) {
        return <BannerLargeImage {...(props as IBannerProps<IBannerImage>)}/>;
    }

    return <BannerImage {...(props as IBannerProps<IBannerImage>)}/>;
}